import { http, tryHttp } from '@/axios/instance/http';
import type { Company, Idp } from '@/types';

export const fetchCompanies = () => {
  return tryHttp(http.get<Company[]>('/companies'));
};

export const fetchIDPs = () => tryHttp(http.get<Idp[]>(`/idps`));

export const updateCompanyImage = (companyId: number, image: File) => {
  const formData = new FormData();
  formData.append('logo_image', image);

  return tryHttp(
    http.patch(`/companies/${companyId}/upload-logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  );
};

export const deleteCompanyImage = (companyId: number) => tryHttp(http.delete(`/companies/${companyId}/delete-logo`));

export const updateCompany = (companyId: number, data: Partial<Company>) =>
  tryHttp(http.patch<Company>(`/companies/${companyId}`, data));
